import { Component } from '@angular/core';
import { MenuItemModel } from '../../utilidades.modelos.index';
import { UtilidadesService } from '../../utilidades.servicios.index';

@Component({
	selector: 'app-inicio',
	templateUrl: './inicio.component.html',
	styleUrls: [
		'./inicio.component.scss'
	]
})
export class InicioComponent {

	public Menu: MenuItemModel[];

	constructor(
		public Utilidades: UtilidadesService
	) {
		this.Utilidades._titulo = "";
		this.Utilidades._menuAbierto = false;

		if (this.Utilidades.Menu.length == 0) {
			//Si tiene permiso a un sólo menu, ya redirecciona.
			this.Utilidades._menuActualizado.subscribe(() => {
				if (this.Utilidades.Menu.length > 0) {
					this.Menu = Utilidades.Menu;
				}

				if (this.Utilidades.Menu.length == 1) {
					if (this.Utilidades.Menu[0].Redireccionar) {
						this.Utilidades.Navegar(this.Utilidades.Menu[0].Ruteo.split('|'));
					}
				}
			});
		}
		else {
			this.Menu = this.Utilidades.Menu;
		}
	}

	SeleccionarModulo(item: MenuItemModel) {
		if (item.Redireccionar) {
			this.Utilidades.Navegar(item.Ruteo.split('|'));
			this.Utilidades._menuAbierto = true;
		}
		else {
			this.Menu = item.SubMenu;
		}
	}

	public IrAInicio(): void {
		this.Menu = this.Utilidades.Menu;
	}
}